import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useUser } from "../../screens/user/context.js/userContext";

const SuccessPaidModal = ({ merchantId }) => {
  const { returnUrl, showSuccess } = useUser();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (showSuccess) {
      if (merchantId === 1) return done();
      setLoading(true);
      setInterval(() => {
        setLoading(false);
        done();
      }, 2000);
    }
  }, [showSuccess, merchantId]);
  const done = () => {
    window.location.href = returnUrl;
  };

  return (
    <Modal
      title=""
      open={showSuccess}
      cancelButtonProps={{ style: { display: "none" } }}
      closable={false}
      onCancel={null}
      footer={null}
      className="invoice-pay-success-modal"
    >
      <div className="successPaidContainer invoice-pay-success">
        <div className="checkmark-container">
          <div className="checkmark-circle invoice-pay-check">
            <div className="checkmark" />
          </div>
        </div>
        <h1 className="success-title">Баяр хүргье!</h1>
        <p className="success-message">Амжилттай төлөгдлөө</p>
        <div className={`bottom-border ${loading ? "loading" : ""}`} />
      </div>
    </Modal>
  );
};

export default SuccessPaidModal;
